module.exports = __webpack_public_path__ + "assets/img/clearwave-90.d5205d6e.webp";